import { render, staticRenderFns } from "./createBatch.vue?vue&type=template&id=f17b8f5a&scoped=true"
import script from "./createBatch.vue?vue&type=script&lang=js"
export * from "./createBatch.vue?vue&type=script&lang=js"
import style0 from "./createBatch.vue?vue&type=style&index=0&id=f17b8f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17b8f5a",
  null
  
)

export default component.exports